"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _joiBrowser = _interopRequireDefault(require("joi-browser"));

var _HttpService = _interopRequireDefault(require("../HttpService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CommentService = /*#__PURE__*/function () {
  function CommentService() {
    _classCallCheck(this, CommentService);
  }

  _createClass(CommentService, null, [{
    key: "isEditCommentRequestValid",
    value: function isEditCommentRequestValid(editCommentRequest) {
      if (editCommentRequest === null || editCommentRequest === undefined) {
        return false;
      }

      var schema = _joiBrowser["default"].object().keys({
        comment: _joiBrowser["default"].string().min(0).max(1024).allow('')
      });

      return _joiBrowser["default"].validate(editCommentRequest, schema).error === null;
    }
  }, {
    key: "editComment",
    value: function editComment(commentId, editCommentRequest) {
      var _this = this;

      if (!Number.isInteger(commentId)) {
        return Promise.reject(new Error('Missing Comment ID'));
      }

      if (!CommentService.isEditCommentRequestValid(editCommentRequest)) {
        return Promise.reject(new Error('Invalid edit comment request'));
      }

      return new Promise(function (resolve, reject) {
        _this.httpService.patch("/".concat(commentId), editCommentRequest).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }, {
    key: "deleteComment",
    value: function deleteComment(commentId) {
      var _this2 = this;

      if (!Number.isInteger(commentId)) {
        return Promise.reject(new Error('Missing Comment ID'));
      }

      return new Promise(function (resolve, reject) {
        _this2.httpService["delete"]("/".concat(commentId)).then(function (response) {
          resolve(response);
        }, function (error) {
          return reject(new Error(error.data.message));
        });
      });
    }
  }]);

  return CommentService;
}();

exports["default"] = CommentService;
CommentService.httpService = new _HttpService["default"]({
  baseURL: "".concat(typeof window !== 'undefined' ? env.REACT_APP_EVENT_API : '', "/comments")
});